import { messages } from '../messages';
import { BundleData } from './types';
import ReactIntl from 'react-intl';

export interface PageHeaderLabelsParameters {
  readonly labels: {
    [key: string]: string;
  };
  readonly bundleData: BundleData;
  readonly skip?: boolean;
}

export type PageHeaderLabels = {
  heading: ReactIntl.FormattedMessage.MessageDescriptor;
  subheading: ReactIntl.FormattedMessage.MessageDescriptor;
};

export const getPageHeaderLabels = ({
  labels,
  bundleData,
  skip
}: PageHeaderLabelsParameters): PageHeaderLabels => {
  if (skip) {
    return {
      heading: messages.heading,
      subheading: messages.subheading
    };
  }
  const editionLabelFragment = getEditionLabelFragment(bundleData.edition);
  const productLabelFragment = getProductLabelFragment(bundleData);

  const headingLabel = `${messages.heading.id}${editionLabelFragment}${productLabelFragment}`;
  const subheadingLabel = `${messages.subheading.id}${editionLabelFragment}${productLabelFragment}`;

  return {
    heading: {
      id: headingLabel,
      defaultMessage: labels[headingLabel] || messages.heading.defaultMessage
    },
    subheading: {
      id: subheadingLabel,
      defaultMessage:
        labels[subheadingLabel] || messages.subheading.defaultMessage
    }
  };
};

export const getEditionLabelFragment = (edition: string) => {
  const matcher: Array<[RegExp, string]> = [
    [/free/gi, 'Free'],
    [/standard/gi, 'Standard'],
    [/premium/gi, 'Standard'],
    [/.*/, 'Free']
  ];

  const [, label] = matcher.find(([regex]) => regex.test(edition)) || [];
  return label;
};

const JSD_KEY = 'jira-servicedesk.ondemand';

export const getProductLabelFragment = (bundleData: BundleData) => {
  switch (bundleData.products[0].productKey) {
    case JSD_KEY:
      return 'JSD';
    default:
      return '';
  }
};
